export const WINDOW_BREAKPOINT_FOR_SIDEBAR = 1217;
